<template>
    <div class="wrapper busyTimeslotsWrapper">
      <Calendar v-model="theDate" :showTime="false" :date-select="_keyUp(value)" :selectOtherMonths="true" :locale="sv" dateFormat="yy-mm-dd" />
      <span v-html="bookedTimes" class="bookedTimes"></span>
    </div>
</template>
<script>
import { abstractField } from 'vue-form-generator'
import { isNil } from 'lodash'
import moment from 'moment'
import Calendar from 'primevue/calendar'
export default {
  components: {
    Calendar,
    moment
  },
  beforeMount () {
    if (isNil(this.value)) {
      this.value = ''
    }
  },
  mixins: [abstractField],
  data () {
    return {
      bookedTimes: '',
      sv: {
        firstDayOfWeek: 1,
        dayNames: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
        dayNamesShort: ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör'],
        dayNamesMin: ['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö'],
        monthNames: [ 'Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December' ],
        monthNamesShort: [ 'Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec' ],
        today: 'Idag',
        clear: 'Rensa',
        dateFormat: 'yy-mm-dd',
        weekHeader: 'vk'
      }
    }
  },
  computed: {
    theDate: {
      get: function () {
        if (this.value !== undefined && this.value !== null && this.value !== '') {
          return new Date(this.value)
        } else {
          return this.value
        }
      },
      set: function (newValue) {
        this.value = moment(newValue).format('YYYY-MM-DD')
        return moment(newValue).format('YYYY-MM-DD')
      }
    }
  },
  methods: {
    async _keyUp (LoadingDate) {
      let getLoadingPlace = this.schema.loadingPlace
      try {
        const { data } = await this.$http.get('/api/orders/api/feralco/busy-time-slots/' + getLoadingPlace + '-' + LoadingDate)
        let strBookedTimes = '<p><strong>Bokade tider</strong></p><ul>'
        if (data['busy-time-slots'].length === 0) {
          strBookedTimes = strBookedTimes + '<li>Alla tider lediga</li></ul>'
          this.bookedTimes = strBookedTimes
        } else {
          data['busy-time-slots'].forEach((value) => {
            strBookedTimes = strBookedTimes + '<li>' + value + '</li>'
          })
          this.bookedTimes = strBookedTimes + '</ul>'
        }
      } catch (e) {
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/vfg-custom-fields/fieldLoadingDate.vue